import { useContext, useEffect, useState } from 'react';
import { services } from '../services/api';
import { useParams } from 'react-router-dom';
import IconUI from '../components/ui/icon_ui'
import { TiArrowBackOutline } from "react-icons/ti";
import { FiMail } from "react-icons/fi";
import Location from '../assets/img/card/Location.svg'
import Phone from '../assets/img/card/Phone.svg'
import PhoneMC from '../assets/img/card/PhoneMC.svg'
import WEB from '../assets/img/card/WEB.svg'

import Escudo from '../assets/img/Escudo.svg'
import GifLoader from "../components/ui/gifLoader"



import { GlobalContext } from '../context/global_context';
import { useHistory } from 'react-router-dom';


export function DependencyView() {

    const { idDependencia } = useParams()

    const { idDep, setIdDep } = useContext(GlobalContext)
    const history = useHistory()

    const [state, setState] = useState({
        info: [],
        loading: false
    })



    useEffect(async () => {

        let isMounted = true
        if (isMounted) {

            setState({ ...state, loading: true })
            let dataAPI;
            
            dataAPI = await services("GET", `publico/mostrarDependencia/${idDependencia}`)


            if (dataAPI.status === "success") {
                setState({ ...state, info: dataAPI.data, loading: false })
            }

        }

        return () => {
            isMounted = false
        }
    }, [])




    return (
        <>
            {state.loading === true ?
                <GifLoader />
                :
                <div id="publicServer" className='publicServer'>
                    <div className="container text-center ">
                        <div className="d-block justify-content-center">
                            <div className="pt-3">
                                <h2 className="text-center text-large text-secondary">
                                    Bienvenido al Directorio Estatal de Servidores Públicos
                                </h2>
                            </div>
                            <div>

                                <div className="mb-4 row row-cols-1 row-cols-md-1 g-4 ">
                                    <div className="col ml-4">
                                        <div className="card card--rounded ">
                                            <div className="card-body">
                                                <div className="d-inline-flex pb-4 input-group justify-content-center">
                                                    <div className='col-2-justify-content-center col-md-2 mb-2'>
                                                        <img src={Escudo} style={{ height: 150, width: 100 }} />
                                                    </div>
                                                    <div className='mt-5 text-center'>
                                                        <h2 className='text-bolder'>{state.info.nombre}</h2>
                                                        <h4 className="text-center text-bolder card-title">{state.info.siglas}</h4>
                                                    </div>
                                                    <div className='pt-2 col-10'>
                                                        <h5 className="text-center">{state.info.descripcion}</h5>
                                                    </div>
                                                </div>

                                                <div className="d-inline-flex pb-4 input-group text-center">
                                                    <div className='col-2 justify-content-start'>
                                                        <img src={Location} style={{ height: 25, width: 25 }} alt="location logo" />
                                                    </div>
                                                    <div className='col-8 text-start'>
                                                        <h6 className='text-bold'>{state.info.direccion? state.info.direccion : "Sin dirección" }</h6>
                                                    </div>
                                                </div>

                                                <div className="d-inline-flex pb-4 input-group text-center">
                                                    <div className='col-2'>
                                                        <img src={Phone} style={{ height: 25, width: 25 }} alt="phone logo" />
                                                    </div>
                                                    <div className='col-4 text-start text-bold'>
                                                        {state.info.telefono ?
                                                            state.info.telefono[0].numero
                                                            :
                                                            'Sin numero'
                                                        }
                                                    </div>
                                                    <div className='col-2 text-center'>
                                                        <img src={PhoneMC} style={{ height: 25, width: 25 }} alt="phonemc logo" />
                                                    </div>
                                                    <div className='col-4 flex text-start'>
                                                        <h6 className='text-bold'> M.C. </h6>
                                                        {state.info.telefono ?
                                                            <div>
                                                                {state.info.telefono[0].marcacion_corta + ''}
                                                            </div>
                                                            :

                                                            <h6> Sin número</h6>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-inline-flex pb-4 justify-content-start input-group ">
                                                    <div className='col-2 justify-content-start '>
                                                        <img src={WEB} style={{ height: 25, width: 25 }} alt="web logo" />
                                                    </div>
                                                    {state.info.url_web?
                                                    <div className='col-4 text-start'>
                                                        {state.info.url_web.map((url)=>{
                                                            return <p><a className='text-bold'href={url}>{url}</a></p>                       
                                                        })}
                                                    </div>
                                                    :
                                                    <div className='col-4 text-start text-bold'>
                                                        Sin Página Web
                                                    </div>
                                                    
                                                    }
                                                    <div className='col-5 d-flex flex-row-reverse'>
                                                        <button className='pill ' onClick={() => {
                                                            setIdDep(state.info.id)
                                                            history.push(`/oficinas/${state.info.id}`)
                                                        }}> Mostrar Oficinas</button>
                                                    </div>
                                                </div>

                                                <div>
                                                    <iframe width="90%" height="500" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src={`https://maps.google.com/maps?width=100%25&height=600&hl=en&q=${state.info.longitud},${state.info.latitud}&t=&z=14&ie=UTF8&iwloc=B&output=embed`}>
                                                        <a href="https://www.maps.ie/distance-area-calculator.html">distance maps</a>
                                                    </iframe>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            }
        </>

    )
}